import { useEffect, useState } from 'react';

interface SafariNavigator extends Navigator {
  standalone: boolean;
}

export const useIsInstalled = () => {
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const isStandalone = globalThis.matchMedia('(display-mode: standalone)').matches || (globalThis.navigator as SafariNavigator).standalone === true;

    setIsInstalled(isStandalone);
  }, []);

  return isInstalled;
};
